import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import { BlockService } from '../../service/BlockService';
import { Router } from '@angular/router';
import { UserService } from '../../service/UserService';
import { environment } from '../../../environments/environment.prod';
import { RoleService } from '../../service/RoleService';
import { DATE_DEFAULT_FORMAT } from '../../model/commons/DateConstants';

@Component({
  selector: 'app-validationVerro',
  templateUrl: './validationVerro.component.html',
  styleUrls: ['./validationVerro.component.css']
})
export class ValidationVerroComponent implements OnInit, AfterViewInit {
  loading = true;
  displayedColumns = ['teamLead', 'tlFullname', 'username', 'ccFullname', 'dateFiche', 'ficheDetails'];
  dataSource = new MatTableDataSource<ValidationVerroVO>();
  constructor(
    private blockService: BlockService,
    private router: Router,
    private roleService: RoleService,
    private userService: UserService){}

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {

    this.blockService.validationVerroRequest().subscribe((res: ValidationVerroVO[])  => {
      this.loading = false;
      const collaborator = this.userService.getUser();
      const avatar: string = collaborator && collaborator.userName;
      const currentOps = environment.verroFiche.onlyOps;
      const currentBUMs = environment.verroFiche.onlyBUMs;
      const isDs = this.roleService.isDS;
      const isMaurice = avatar && avatar.startsWith('R');
      const otherOps = !isMaurice && this.roleService.isOps && currentOps.indexOf(avatar) == -1;
      const otherBUMs = !isMaurice && this.roleService.isBUM && currentBUMs.indexOf(avatar) == -1;
      if(isMaurice) res = res.filter(r => moment(moment(r.dateFiche).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(environment.verroFiche.exceptionDateOfMaurice));
      if(isDs) res = res.filter(r => moment(moment(r.dateFiche).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(environment.verroFiche.exceptionDate));
      if(otherBUMs || otherOps) res = res.filter(r => moment(moment(r.dateFiche).format(DATE_DEFAULT_FORMAT)).isSameOrAfter(environment.verroFiche.generalExceptionDate));
      this.dataSource.data = res;
    });
  }

  filterDatatable(value: string) {
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }


  goToFiche(element: ValidationVerroVO){
    this.router.navigate(['/timesheet']);
  }
  /**
   * Set the paginator after the view init since this component will
   * be able to query its view for the initialized paginator.
   */
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

}

export interface ValidationVerroVO {
  teamLead: string;
  tlFullname: string;
  username: string;
  ccFullname: string;
  dateFiche: string;
  lock: boolean;
}

// const DATA: ValidationVerroVO[] = [
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'},
//   { CC: 'Youssef Eloualid [997389]', Date: moment(new Date()).format('DD/MM/YYYY'), TL: 'Tarek skaly [E20142]'}
// ];



// WEBPACK FOOTER //
// ./src/app/view/validationVerro/validationVerro.component.ts